module.exports = __webpack_public_path__ + "img/Flag_of_Israel.d47f60b6.svg";